/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Other_PlanInputs */

const en_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other plans`)
};

const ar_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other plans`)
};

const de_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other plans`)
};

const es_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other plans`)
};

const fr_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other plans`)
};

const it_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other plans`)
};

const ja_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other plans`)
};

const ko_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other plans`)
};

const pt_br_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other plans`)
};

const ru_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other plans`)
};

const th_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other plans`)
};

const tr_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other plans`)
};

const zh_cn_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他方案`)
};

const zh_tw_other_plan = /** @type {(inputs: Other_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他方案`)
};

/**
* | output |
* | --- |
* | "other plans" |
*
* @param {Other_PlanInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const other_plan = /** @type {((inputs?: Other_PlanInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Other_PlanInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_other_plan(inputs)
	if (locale === "ar") return ar_other_plan(inputs)
	if (locale === "de") return de_other_plan(inputs)
	if (locale === "es") return es_other_plan(inputs)
	if (locale === "fr") return fr_other_plan(inputs)
	if (locale === "it") return it_other_plan(inputs)
	if (locale === "ja") return ja_other_plan(inputs)
	if (locale === "ko") return ko_other_plan(inputs)
	if (locale === "pt_br") return pt_br_other_plan(inputs)
	if (locale === "ru") return ru_other_plan(inputs)
	if (locale === "th") return th_other_plan(inputs)
	if (locale === "tr") return tr_other_plan(inputs)
	if (locale === "zh_cn") return zh_cn_other_plan(inputs)
	return zh_tw_other_plan(inputs)
});